export default "__VITE_ASSET__Do965Efx__"